import React from 'react'
import { useLanguage } from '~components'
import wwIcon from '../../../../assets/images/newimage/WW.svg'
import likeIcon from '../../../../assets/images/newimage/like.svg'
import wicarIcon from '../../../../assets/images/newimage/wicar.svg'
import calenderIcon from '../../../../assets/images/newimage/calender.svg'
import wheelIcon from '../../../../assets/images/newimage/wheel.svg'
import alarmIcon from '../../../../assets/images/newimage/alarm.svg'
import ccIcon from '../../../../assets/images/newimage/cc.svg'
import locationIcon from '../../../../assets/images/newimage/location.svg'

import {
  PageContainer,
  HeroSection,
  PageTitle,
  HeroSubtitle,
  PinkBtn,
  HeroNote,
  TwoColGrid,
  LeftCol,
  RightCol,
  ColTitle,
  OverviewCard,
  OverviewCardTitle,
  OverviewCardText,
  IconCardsRow,
  IconCard,
  IconCardLabel,
  IconCardSub,
  WhoGrid,
  WhoCard,
  WhoCardLabel,
  YellowCard,
  YellowCardBrand,
  YellowCardText,
  YellowCardBrand2,
  FullSection,
  SectionTitle,
  ServingSection,
  ServingTitle,
  ServingText,
  FAQGrid,
  FAQCard,
  FAQCardTitle,
  FAQCardText,
  BottomBar,
  BottomText,
  BottomBtn
} from './styles'

/* ─────────────────────────────────────────────────────
   SVG ICONS
───────────────────────────────────────────────────── */
// Inline SVGs removed and replaced by imported assets

export const RunnerPage = () => {
  const [, t] = useLanguage()

  return (
    <PageContainer>

      {/* ── Hero ── */}
      <HeroSection>
        <PageTitle>
          {t('RUNNER_HERO_TITLE', 'OPERATE YOUR OWN DELIVERY ROUTE')}
        </PageTitle>
        <HeroSubtitle>
          {t('RUNNER_HERO_SUB', "Own your market. Drive your success. Join Canada's fastest growing late-night delivery network.")}
        </HeroSubtitle>
        <PinkBtn href='tel:+1234567890'>
          {t('CALL_NOW', 'CALL NOW')}
        </PinkBtn>
        <HeroNote>
          {t('RUNNER_HERO_NOTE', 'Can your shortformowyour market')}
        </HeroNote>
      </HeroSection>

      {/* ── Overview (left) + Requirements (right) ── */}
      <TwoColGrid>
        <LeftCol>
          <ColTitle>{t('OVERVIEW', 'OVERVIEW')}</ColTitle>

          <OverviewCard>
            <OverviewCardTitle>{t('BE_YOUR_OWN_BOSS', 'Be Your Own Boss')}</OverviewCardTitle>
            <OverviewCardText>
              {t('BE_BOSS_TEXT', 'Vian your market.bit is be yesa sheatin eat truct dik the be postive ad ine istlyes sol onigis driternin envet coinsiler actorpert.')}
            </OverviewCardText>
          </OverviewCard>

          <OverviewCard>
            <OverviewCardTitle>{t('FLEXIBLE_HOURS', 'Flexible Hours')}</OverviewCardTitle>
            <OverviewCardText>
              {t('FLEXIBLE_TEXT', 'The your envest there doesnt be hecarmon tebvit freshent. Fond trew and iastconine aelsanga tolt tour norest isni mised.')}
            </OverviewCardText>
          </OverviewCard>
        </LeftCol>

        <RightCol>
          <ColTitle>{t('REQUIMENTS', 'REQUIMENTS')}</ColTitle>
          <IconCardsRow>
            <IconCard>
              <img src={wheelIcon} alt='license' />
              <IconCardLabel>{t('WLUB_LISENISE', 'WLUB LISENISE')}</IconCardLabel>
              <IconCardSub>{t('RUNDALE_VAHDLE', 'Rundale Vahdle')}</IconCardSub>
            </IconCard>
            <IconCard>
              <img src={alarmIcon} alt='request' />
              <IconCardLabel>{t('FIUET_POIUE', 'FIUET POIUE')}</IconCardLabel>
              <IconCardSub>{t('RUBELE_VORTUBE', 'Rubele Vortube')}</IconCardSub>
            </IconCard>
          </IconCardsRow>
          <ColTitle style={{ marginTop: '20px' }}>
            {t('HOW_IT_WORKS', 'HOW IT WORKS')}
          </ColTitle>
          <IconCardsRow>
            <IconCard>
              <img src={ccIcon} alt='receipt' />
              <IconCardLabel>{t('RECEEINE_ORISEES', 'RECEEINE ORISEES')}</IconCardLabel>
            </IconCard>
            <IconCard>
              <img src={locationIcon} alt='territory' />
              <IconCardLabel>{t('SUUED_TEBRIDROTY', 'SUUED YOUR TEBRIDROTY')}</IconCardLabel>
            </IconCard>
          </IconCardsRow>
        </RightCol>
      </TwoColGrid>

      {/* ── HOW IT WORKS (left yellow) + WHO THIS IS FOR (right 2×2) ── */}
      <TwoColGrid>
        <LeftCol>
          <ColTitle>{t('HOW_IT_WORKS', 'HOW IT WORKS')}</ColTitle>
          <YellowCard>
            <YellowCardBrand>{t('BOTTLE_RUNNERS', 'Bottle Runners')}</YellowCardBrand>
            <YellowCardText>
              {t('BOTTLE_RUNNERS_DESC', 'Private-label beverage distribution. Event activations. Affiliate-driven expansion.')}
            </YellowCardText>
            <YellowCardBrand2>{t('REBOOT_NIGHT', 'Reboot the Night')}</YellowCardBrand2>
            <YellowCardText style={{ marginBottom: 0 }}>
              {t('REBOOT_DESC', 'Aut Kost Btlens slctribution, trybrute sind territory expansion.')}
            </YellowCardText>
          </YellowCard>
        </LeftCol>

        <RightCol>
          <ColTitle>{t('WHO_THIS_IS_FOR', 'WHO THI IS FOR')}</ColTitle>
          <WhoGrid>
            <WhoCard>
              <img src={likeIcon} alt='Entrepremeurs' />
              <WhoCardLabel>{t('ENTREPREMEURS', 'Entrepremeurs')}</WhoCardLabel>
            </WhoCard>
            <WhoCard>
              <img src={wwIcon} alt='Self-Starters' />
              <WhoCardLabel>{t('SELF_STARTERS', 'Self-Starters')}</WhoCardLabel>
            </WhoCard>
            <WhoCard>
              <img src={wicarIcon} alt='Sules-Driven' />
              <WhoCardLabel>{t('SULES_DRIVEN', 'Sules-Driven')}</WhoCardLabel>
            </WhoCard>
            <WhoCard>
              <img src={calenderIcon} alt='Recurring Income' />
              <WhoCardLabel>{t('RECURRING_INCOME', 'Recuríng Incoma')}</WhoCardLabel>
            </WhoCard>
          </WhoGrid>
        </RightCol>
      </TwoColGrid>

      {/* ── Serving the Ottawa Area ── */}
      <ServingSection>
        <ServingTitle>{t('SERVING_OTTAWA', 'Serving the Ottawa Area')}</ServingTitle>
        <ServingText>
          {t('SERVING_TEXT', "Own your market. Drive your success. Join Canada's fastest growing late-night delivery network.")}
        </ServingText>
      </ServingSection>

      {/* ── FAQ ── */}
      <FullSection>
        <SectionTitle>{t('FAQ', 'FAQ')}</SectionTitle>
        <FAQGrid>
          <FAQCard>
            <FAQCardTitle>{t('FAQ', 'FAQ')}</FAQCardTitle>
            <FAQCardText>
              {t('FAQ_TEXT_1', 'Criminef opral bant care canarita tito thevousite pealimon wallet')}
            </FAQCardText>
          </FAQCard>
          <FAQCard>
            <FAQCardTitle>{t('FAQ', 'FAQ')}</FAQCardTitle>
            <FAQCardText>
              {t('FAQ_TEXT_2', 'Tlonse ttixt idealiovetat eroon sito ane acerta craeenost slot wisle petit')}
            </FAQCardText>
          </FAQCard>
        </FAQGrid>
      </FullSection>

      {/* ── Sticky Bottom Bar ── */}
      <BottomBar>
        <BottomText>{t('PLACE_ORDER_DELIVERY', 'PLACE AN ORDER FOR DELIVERY')}</BottomText>
        <BottomBtn onClick={() => { window.location.href = t('CALL_NOW_LINK', 'tel:+1234567890') }}>{t('START_ORDER', 'START ORDER')}</BottomBtn>
      </BottomBar>

    </PageContainer>
  )
}

export default RunnerPage
